// Tours quoted on WhatsApp (no payment on the site): price unit, booking panel and the quote dialog.
export default {
  quote: {
    title: 'Peça sua cotação',
    unit: { boat: 'pela lancha completa', schooner: 'pela escuna completa', group: 'pelo grupo' },
    calendarPrice: { boat: '{{price}} pela lancha completa', schooner: '{{price}} pela escuna completa', group: '{{price}} pelo grupo' },
    priceLine: { boat: 'Lancha completa', schooner: 'Escuna completa', group: 'Grupo privativo' },
    peopleTitle: 'Quantas pessoas',
    people: 'Pessoas',
    peopleHint: 'Todos que vão no passeio',
    estimate: 'Valor de referência',
    badge: 'Cotação pelo WhatsApp',
    note: 'Sem pagamento pelo site: escolha a data e quantas pessoas vão, e a nossa equipe responde pelo WhatsApp se está disponível.',
    ask: 'Pedir cotação pelo WhatsApp',
    askShort: 'Pedir cotação',
    secure: 'Sem pagamento pelo site: a equipe responde a sua cotação pelo WhatsApp.',
    count_one: '{{count}} pessoa',
    count_other: '{{count}} pessoas',
    adults_one: '{{count}} adulto',
    adults_other: '{{count}} adultos',
    children_one: '{{count}} criança',
    children_other: '{{count}} crianças',
    babies_one: '{{count}} bebê',
    babies_other: '{{count}} bebês',
    modal: {
      title: 'Pedir cotação',
      lead: 'Escreva seu nome: o WhatsApp abre com o pedido pronto, é só enviar.',
      tour: 'Passeio',
      date: 'Data',
      people: 'Pessoas',
      name: 'Nome completo',
      namePlaceholder: 'Nome e sobrenome',
      nameError: 'Escreva seu nome completo.',
      send: 'Enviar pelo WhatsApp',
      hint: 'Nossa equipe responde pelo WhatsApp se a data está disponível.',
      close: 'Fechar',
      sentTitle: 'Pedido pronto no WhatsApp',
      sentText: 'Envie a mensagem no WhatsApp. A nossa equipe responde se a data está disponível.',
      again: 'Abrir o WhatsApp de novo',
      done: 'Concluir',
    },
  },
};
